import React, { useEffect } from 'react';
import { scrollToPageElement } from 'utils/componentsCommon';
import PropTypes from 'prop-types';
import { useLocation } from 'react-use';

const FaqQuestions = ({ categoriesAndEntries }) => {

    const { pathname, hash, key } = useLocation();
    // could probably be refactored into its own hook
    useEffect(() => {
        const stepElement = document.getElementById(hash.replace('#', ''));
        if (hash.length) stepElement.scrollIntoView();
    }, [pathname, hash, key]);

    const handleClick = entry => {
        scrollToPageElement(`#faqanswer${entry.id}`, 20);
    };

    return (
        <>
            <article className="faqQuestions">
                { categoriesAndEntries.map(category => (
                    <div key={ category.name }>
                        <h4>{ category.name }</h4>
                        <ul>
                            { category.entries
                                .map(entry => (
                                    <li key={ entry.id }>
                                        <a onClick={ () => handleClick(entry) }>{ entry.question }</a>
                                    </li>
                                )) }
                        </ul>
                    </div>
                )) }
            </article>
        </>
    );
};

FaqQuestions.defaultProps = {};
FaqQuestions.propTypes = {
    categoriesAndEntries: PropTypes.array,
};

export default FaqQuestions;
